import Serializer from 'umg-ember-backend/serializers/application';

export default class UrlAliasSerializer extends Serializer {
  attrs = {
    position: 'cmsPosition',
  };
}
